import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { AppraisalDataService } from '../../shared/services/appraisal-data.service';
import { LookupService } from '../../shared/services/lookup.service';
import { forkJoin } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { isRowInvalid } from '../../shared/utils/row-validation.util';
interface CustomButtonParams extends ICellRendererParams {
  onClick: () => void;
}

@Component({
  selector: 'app-grid-row-actions',
  standalone: true,
  imports: [CommonModule, MatIconModule, RouterModule],
  templateUrl: './grid-row-actions.component.html',
  styleUrl: './grid-row-actions.component.scss'
})
export class GridRowActionsComponent implements ICellRendererAngularComp {
  rowData: any;
  onClick!: (data: any) => void;
  lookupValues: { [key: string]: string[] } = {};
  invalid = false;
  isFileAvailable: boolean = false;
  constructor(private router: Router, private appraisalDataService: AppraisalDataService, private lookupService: LookupService) {}

  agInit(params: any): void {
    this.rowData = params.data; // Capture row data
    this.onClick = params.onClick;

    setTimeout(() => forkJoin({
      country: this.lookupService.getAllowedValues('CountryName'),
      city: this.lookupService.getAllowedValues('CityName'),
      state: this.lookupService.getAllowedValues('StateName'),
      zipCode: this.lookupService.getAllowedValues('ZipCode'),
      propertyType: this.lookupService.getAllowedValues('PropertyType'),
      areaMeasure: this.lookupService.getAllowedValues('AreaMeasureName'),
      countryAbbs: this.lookupService.getLookupItems("CountryName"),
      stateAbbs: this.lookupService.getLookupItems("StateName"),
      partnerInfo: this.lookupService.getLookupItems("Partner"),
      hvacType: this.lookupService.getAllowedValues('HVACType'),
      utilityPaidBy: this.lookupService.getAllowedValues('UtilityPaidBy'),
      landOwnershipInterest: this.lookupService.getAllowedValues('LandOwnershipInterest')
      // Add additional lookup observables as needed.
    }).subscribe((result: any) => {
      // Store the lookup values in an object using keys that match your ValidatorsMap keys.
      this.lookupValues = {
        CountryName: result.country,
        CityName: result.city,
        StateName: result.state,
        ZipCode: result.zipCode,
        PropertyType: result.propertyType,
        AreaMeasureName: result.areaMeasure,
        HVACType: result.hvacType,
        UtilityPaidBy: result.utilityPaidBy,
        LandOwnershipInterest: result.landOwnershipInterest
      };
      
      this.invalid = isRowInvalid(this.rowData, this.lookupValues);
      this.isFileAvailable = (this.rowData.fileName == '' || this.rowData.fileName == null) ? false : true;
    }));

  }

  refresh(params: any) {
    return true;
  }

  navigateToDetails() {
    this.appraisalDataService.setRowData(this.rowData);
    const url = this.router.serializeUrl(this.router.createUrlTree(['/activity-details', this.rowData.activityNumber]));
    const newWindow = window.open(url, '_blank');

    if (newWindow) {
      newWindow.focus();
      setTimeout(() => this.appraisalDataService.setRowData(null), 0);
    } else {
      this.router.navigate(['/activity-details', this.rowData.activityNumber]);
    }
  }


  downloadFile(){
    this.appraisalDataService.downloadfile(this.rowData.activityNumber).subscribe({
      next: (res: HttpResponse<Blob>) => {
        // 1) figure out the filename from the Content-Disposition header
        const contentDisp = res.headers.get('content-disposition') || '';
        const fileNameMatch = /filename="?(.+\.xlsm)"?/.exec(contentDisp);
        // if header was present and ends in .xlsm, use it; otherwise default:
        const filename = fileNameMatch
          ? fileNameMatch[1]
          : `${this.rowData.activityNumber}.xlsm`;

        // --- 2) create a Blob URL and force a download
        const blob = new Blob([res.body!], { type: res.body!.type });
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();

        // --- 3) cleanup
        document.body.removeChild(a);
        window.URL.revokeObjectURL(blobUrl);
      },
      error: err => {
        console.error('Download failed', err);
        alert('Unable to download file. Please try again.');
      }
    });
  }  
}
